const authUserId = localStorage.getItem('authId')

export default authUserId